// noinspection ExceptionCaughtLocallyJS

import axios from "axios";
import {call, fork, put, take, cancel, cancelled, delay} from "redux-saga/effects";
import {
  Console_Page_functionRoles,
  Fetch_User_Enterprise_Roles_Privilege_Success,
} from "reducers/userData";
import {AxiosError} from "axios";

export const LOGIN = 'authentication/LOGIN';
const LOGIN_BEGIN= 'authentication/LOGIN_BEGIN'
export const LOGIN_SUCCESS = 'authentication/LOGIN_SUCCESS';
const LOGIN_REPEAT = 'authentication/LOGIN_REPEAT';
const LOGIN_FAIL = 'authentication/LOGIN_FAIL';
const LOGIN_CANCEL = 'authentication/LOGIN_CANCEL';
export const RESET_LOGIN_REPEAT = 'authentication/RESET_LOGIN_REPEAT';

export const LOGOUT = 'authentication/LOGOUT';
export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS';
const AUTHENTICATION_EXPIRED = 'authentication/AUTHENTICATION_EXPIRED';
export const RESET_AUTHENTICATION_EXPIRED = 'authentication/RESET_AUTHENTICATION_EXPIRED';

export const NETWORK_ERROR = "authentication/NETWORK_ERROR";

export const RESET_NETWORK_ERROR = "authentication/RESET_NETWORK_ERROR"


const initialState = {
  isAuthenticated: false,
  username: "",
  userId: "00000000-0000-0000-0000-000000000000",
  loading: true,
  isAuthenticationExpired: false,
  isAlreadyLoginSomewhere: false,
  //TODO:被已注释代码使用，因此先注释
  // visitTime:null,
  // loginTimeOut:false,
  loginError:"",
  //TODO: 网络请求失败标记位，可能需要改名
  isNetworkError: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: action.data.authenticated,
        username: action.data.userName,
        userId: action.data.id,
        loginError: "",
      };
    case LOGIN_FAIL: {
      if(action.data === "error/network")
        return {
          ...state,
          loading: false,
          isAuthenticated: false,
          username: null,
          userId: null,
          loginError: action.data,
          apiMeRequestFail: true
        };
      else if(action.data === "error/not_auth"){
        return {
          ...state,
          loading: false,
          isAuthenticated: false,
          username: null,
          userId: null,
          loginError: action.data,
        };
      }
      else
        return {
          ...state,
          loading: false,
          isAuthenticationExpired: true,
          isAuthenticated: false,
          username: null,
          userId: null,
          loginError: action.data,
        };
    }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        username: null,
        userId: null,
      };
    case LOGIN_REPEAT:
      return {
        ...state,
        loading: false,
        isAlreadyLoginSomewhere: true
      };
    case LOGIN_CANCEL:
      return {
        ...state,
        loading:false
      };
    case RESET_LOGIN_REPEAT:
      return {
        ...state,
        isAlreadyLoginSomewhere: false
      };
    case AUTHENTICATION_EXPIRED:
      return {
        ...state,
        isAuthenticationExpired: true
      }
    case RESET_AUTHENTICATION_EXPIRED:
      return {
        ...state,
        isAuthenticationExpired: false
      };
    case NETWORK_ERROR:
      return {
        ...state,
        isNetworkError: true
      };
    case RESET_NETWORK_ERROR:
      return {
        ...state,
        isNetworkError: false
      };
    default:
      return state;
  }
}

export const authenticationSagas=[
  fork(loginFlow),
  fork(heartbeatFlow)
];

function* loginFlow() {
  const initTask = yield fork(authorize, false);
  while (true) {
    const loginAction = yield take([LOGIN,LOGIN_SUCCESS,LOGIN_REPEAT]);
    // fork return a Task object
    let task = null;
    if(loginAction.type === LOGIN) {
      task = yield fork(authorize, true);
      yield cancel(initTask);
    }
    const action = yield take([LOGOUT, LOGIN_FAIL, RESET_LOGIN_REPEAT , AUTHENTICATION_EXPIRED])
    if (action.type === LOGOUT || action.type === RESET_LOGIN_REPEAT)
      if(task !== null) {
        yield cancel(task);
      }
    // if(action.type === LOGOUT || action.type === AUTHENTICATION_EXPIRED)
    //   yield fork(logout, {type: LOGOUT_SUCCESS})
    if(action.type === LOGOUT )
      yield fork(logout, {type: LOGOUT_SUCCESS, payload: action.payload})
    if(action.type === AUTHENTICATION_EXPIRED) {
      yield fork(logout, {type: LOGOUT_SUCCESS})
    }
  }
}

function* heartbeatFlow(){
  while(true){
    const user = yield take(LOGIN_SUCCESS);
    const task = yield fork(heartbeat,user);
    const action = yield take([LOGOUT,AUTHENTICATION_EXPIRED]);
    yield cancel(task);
  }
}

function* authorize(isNeedRedirect) {
  yield put({type: LOGIN_BEGIN});
  try {
    const userResponse = yield call(userLogin)
    if(!!userResponse.data&&!!userResponse.data.name){
      const enterpriseResponse=yield call(fetchEnterprises,userResponse.data.attributes.id);
      if(!enterpriseResponse.data){
        throw "error/fetch_enterprises_error";
      }
      if(enterpriseResponse.data.length !== 0) {
        const currentEnterpriseResponse = yield call(fetchCurrentEnterprise, userResponse.data.attributes.id);
        //判断索引时，存在0的情况，在判断时需区分
        if (currentEnterpriseResponse.data === undefined){
          throw "error/fetch_current_enterprise_error";
        }
        const rolesResponse = yield call(fetchUserEnterpriseRoles, userResponse.data.attributes.id,
          enterpriseResponse.data[currentEnterpriseResponse.data].id);
        if (!rolesResponse.data){
          throw "error/fetch_roles_error";
        }
        rolesResponse.data.unshift({
          id:"00000000-0000-0000-0000-000000000000",
          code: "0000000",
          name: "所有角色"
        })
          //此处不考虑数组长度为0的情况，因为每个企业最少有2个角色
        const currentRoleResponse = yield call(fetchCurrentRole, userResponse.data.attributes.id, enterpriseResponse.data[currentEnterpriseResponse.data].id);
        if(currentRoleResponse.data === undefined){
          throw "error/fetch_roles_error";
        }

        yield put({
          type: LOGIN_SUCCESS,
          data: {
            authenticated: true,
            userName: userResponse.data.attributes.username,
            id: userResponse.data.attributes.id,
            enterprises: enterpriseResponse.data,
            currentEnterprise: currentEnterpriseResponse.data,
            roles: rolesResponse.data,
            currentRole:currentRoleResponse.data
          }
        });
        const functionRolesResponse = yield call(getFunctionRolesAction,userResponse.data.attributes.id);
        if(functionRolesResponse.data)
        {
          yield put({
            type: Console_Page_functionRoles,
            data: functionRolesResponse.data
          });
        }
        const privilegeResponse = yield call(fetchUserRolePrivilege,userResponse.data.attributes.id,enterpriseResponse.data[currentEnterpriseResponse.data].id,rolesResponse.data[currentRoleResponse.data].id);
        if(privilegeResponse.data)
        {
          yield put({
            type: Fetch_User_Enterprise_Roles_Privilege_Success,
            data: privilegeResponse.data
          });
        }
      }
      else {
        yield put({
          type: LOGIN_SUCCESS,
          data: {
            authenticated: true,
            userName: userResponse.data.attributes.username,
            id: userResponse.data.attributes.id,
            enterprises: enterpriseResponse.data,
            currentEnterprise: -1,
            roles:[
            ],
            currentRole: -1
          }
        });
        const functionRolesResponse = yield call(getFunctionRolesAction,userResponse.data.attributes.id);
        if(functionRolesResponse.data)
        {
          yield put({
            type: Console_Page_functionRoles,
            data: functionRolesResponse.data
          });
        }
        const privilegeResponse = yield call(fetchUserRolePrivilege,userResponse.data.attributes.id,null,null);
        if(privilegeResponse.data)
        {
          yield put({
            type: Fetch_User_Enterprise_Roles_Privilege_Success,
            data: privilegeResponse.data
          });
        }

      }
    }else{
      if(userResponse.data === LOGIN_REPEAT){
        yield put({type:LOGIN_REPEAT});
      }else if(userResponse.data === "Query TGT failed"){
        throw "error/query_TGT_failed";
      }else if(userResponse.data === "Ip changed") {
        throw "error/ip_changed";
      }else{
        if (isNeedRedirect) {
          const location = window.location.href;
          const casUrlResponse = yield call(fetchCasUrl);
          window.location.href = casUrlResponse.data + `/cas/login?service=${location}`;
        }else{
          throw "error/not_auth";
        }
      }
    }
  } catch(error) {
    if(error instanceof AxiosError){
      let error_message = "";
      if (error.response) {
        if(process.env.NODE_ENV === 'development'){
          error_message = "error/network";
        }else{
          error_message = "error/bad_request";
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        if(error.code === AxiosError.ERR_NETWORK)
          error_message = "error/network";
        else
          error_message = "error/bad_request";
      } else {
        // Something happened in setting up the request that triggered an Error
        error_message = "error/bad_request";
      }

      if(!error.config.url.includes("/api-me")){
        yield fork(logout,{type: LOGIN_FAIL, data: error_message});
      }else{
        yield put({type: LOGIN_FAIL, data: error_message});
      }
    }else{
      if(error === "error/not_auth"){
        yield put({type: LOGIN_FAIL, data: error});
      }else {
        yield fork(logout, {type: LOGIN_FAIL, data: error});
      }
    }
  } finally {
    if (yield cancelled()) {
      yield put({type: LOGIN_CANCEL});
    }
  }
}
function getFunctionRolesAction(userId) {
  return axios({
    method: "get",
    url: `/api-user/function/getFunctionRoles?userId=${userId}`,
    withCredentials: true
  });
}


function* logout(action){

  try {
    const casUrlResponse = yield call(fetchCasUrl);
    if(!casUrlResponse.data){
      throw "error/fetch_cas_url_error";
    }
    const casLogoutResponse = yield call(casLogout, casUrlResponse.data)

    if(casLogoutResponse.status !== 200){
      throw "error/cas_logout_error";
    }

    const foundationLogoutResponse = yield call(foundationLogout);
    if(foundationLogoutResponse.status !== 200){
      throw "error/foundation_logout_error";
    }

    yield put(action);

    if(action.type === LOGOUT_SUCCESS && action.hasOwnProperty('payload')) {
      const {history} = action.payload;
      history.push('/');
    }

  }catch (e) {
    yield put({type: 'LOGOUT_ERROR', e});
  }
}

function* heartbeat(user) {
  while (true) {
    yield delay(60000);
    try {
      const response = yield call(userLogin);
      if (response === undefined || response.data === undefined ||
        response.data === null || response.data === "Query TGT failed" ||
        response.data === "Ip changed" || response.data === '' ||
        response.data.name === undefined || response.data.attributes.username !== user.data.userName) {
        yield put({type: AUTHENTICATION_EXPIRED});
      }
    }catch (error) {
      if(error instanceof AxiosError){
        let error_message = "error/network";
        yield put({type: NETWORK_ERROR});
      }
    }
  }
}

function userLogin(){
  return axios({
    url: "/api-me/",
    method: "GET",
    withCredentials: true
  });
}

function fetchEnterprises(userId){
  return axios({
    url: `/api-user/users/${userId}/enterprises`,
    method: "GET",
    withCredentials: true
  });
}

function fetchCurrentEnterprise(userId){
  return axios({
    url: `/api-user/currentEnterprise/?id=${userId}`,
    method: "GET",
    withCredentials: true
  });
}

function fetchUserEnterpriseRoles(userId, enterpriseId){
  return axios({
    url: `/api-user/users/${userId}/enterprises/${enterpriseId}/roles`,
    method: "GET",
    withCredentials: true
  });
}

function fetchCurrentRole(userId, enterpriseId){
  return axios({
    url: `/api-user/currentRoleEnterprise/?id=${userId}&enterpriseId=${enterpriseId}`,
    method: "GET",
    withCredentials: true
  });
}

function fetchUserRolePrivilege(userId,enterpriseId,roleId){
  const appName = "00000000-0000-0000-0000-000000000000";
  return axios({
    url: `/api-user/applications/${appName}/privileges?userId=${userId}${!!enterpriseId?`&enterpriseId=${enterpriseId}&roleId=${roleId}`:""}`,
    method: "GET",
    withCredentials: true
  });
}

export function fetchCasUrl(){
  return axios({
    url: "/cas-url",
    method: "GET",
    withCredentials: true
  });
}

function casLogout(casUrl){
  return axios({
    url: `${casUrl}/cas/logout`,
    method: "GET",
    withCredentials: true
  });
}

function foundationLogout(){
  return axios({
    url: `/delete-session`,
    method: "GET",
    withCredentials: true,
  });
}
